<template>
    <div class="profile-edit">
        <data-form title="Edit My Profile"
                   tag="profile-edit"
                   save-button-label="Save"
                   :field-model="userFields"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   cancelRoute="/profile/view"
                   submit-success-message="Profile updated"
                   submit-error-message="Error updating my profile"
                   submit-success-route="/profile/view">
        </data-form>
    </div>
</template>

<script>

import Vue from 'vue'
import UserFields from '@/models/User'

/**
 * Page for admin to edit agency information
 */
export default Vue.extend({
    name: 'ProfileEdit',
    data () {
        return {
            userFields: UserFields,
        }
    },
    computed: {
        fieldGroups () {
            return [
                ['id', 'email_edit', 'first_name', 'last_name', 'phone_office', 'phone_mobile']
            ]
        },
    },
    methods: {
        loadModelInstance () {
            return this.$api.getItem(this, 'user', this.$user.userId())
        },
        onSubmit (modelInstance) {
            return this.$api.updateItem(this, 'user', modelInstance)
        }
    },
    created () {
        this.$api.getItem(this, 'user', this.$user.userId())
            .then((data) => {
                this.userInfo = data
            })
    },
})

</script>

